import React from 'react'
import { TextViewModel, FormField } from '@sitecore-jss/sitecore-jss-forms'
import { FieldWithValueProps } from '@sitecore-jss/sitecore-jss-react-forms/types'

const TextViewField: React.FunctionComponent<
  FieldWithValueProps<FormField<TextViewModel>>
> = ({ field }) => {
  let textField = field.model.text
  let name = field.model.name

  return (
    <div
      className={`${
        name === 'FormTitle' || name === 'EmailAlertText'
          ? 'sitecore-jss-form--titleText'
          : ''
      } ${
        name === 'PrivacyPolicyText' ||
        name === 'DataCategoryText' ||
        name === 'YourInformationText' ||
        name === 'ConsentText' ||
        name === 'MarketingActivitiesText'
          ? 'sitecore-jss-form--subTitleText'
          : ''
      } ${name === 'ConsentText' ? 'sitecore-jss-form--consentText' : ''} ${
        name === 'SubscriberText' ? 'sitecore-jss-form--subscriberText' : ''
      }
      ${name === 'ConsentDetails' ? 'sitecore-jss-form--consentDetails' : ''}
      ${
        name === 'MarketingActivitiesText'
          ? 'sitecore-jss-form--marketingActivitiesText'
          : ''
      }`}
    >
      <div
        dangerouslySetInnerHTML={{
          __html: `${textField}`,
        }}
      ></div>
    </div>
  )
}

export default TextViewField
